import Radio from "backbone.radio";
import { useEffect } from "react";

import { store } from "common/store";
import strings from "common/strings";

import { AuthRoute, useRouteMatch, Switch, useParams } from "extensions/react-router";

import { ensureErrorCallback } from "common/components/error";

export function ReportsRouter() {
    const { url } = useRouteMatch();
    return (
        <Switch>
            <AuthRoute path={`${url}/reports/packaged/:id/:template_ref/:slide?`} component={PackagedReports} />
            {/* Analytics reports use /reports path also, so these must be exact */}
            <AuthRoute exact path={[`${url}/reports`, `${url}/reports/packaged_reports/:context?`]} component={AllPackagedReports} />
            <AuthRoute exact path={`${url}/reports/saved_reports`} component={AllSavedReports} />
        </Switch>
    );
}

function PackagedReports({ match }) {
    const { id, template_ref, slide } = useParams();

    useEffect(() => {
        async function main() {
            try {
                const { OverlayedPackageReport } = await import(
                    /* webpackChunkName: "packaged_reports" */
                    "./packaged_reports"
                );
                
                Radio.channel("main").request("show:app:view", <OverlayedPackageReport id={id} template_ref={template_ref} slide={Number.parseInt(slide || 1, 10)}/>, {
                    name: "Reports",
                    waitForAttach: true,
                    hideDatePicker: true,
                    asyncName: true
                });
            } catch (error) {
                ensureErrorCallback(error);
            }
        }

        main();
    }, [id, template_ref, slide]);

    return null;
}

function AllPackagedReports(...props) {
    return <AllReports level="packaged_reports" {...props} />;
}

function AllSavedReports(...props) {
    return <AllReports level="saved_reports" {...props} />;
}

function AllReports({ match, level }) {
    const { context, options } = useParams();
    useEffect(() => {
        async function main() {
            if (store.getState().permissions.user_permissions.feature_packaged_reports) {
                try {
                    const { Reports } = await import(
                        /* webpackChunkName: "reports" */
                        "./reports"
                    );
        
                    Radio.channel("main").request("show:app:view", <Reports section={context} initialLevel={level}/>, {
                        name: "Reports",
                        hideDatePicker: true
                    });
                } catch (error) {
                    ensureErrorCallback(error);
                }
            } else {
                try {
                    const { ReportsPage } = await import(
                        /* webpackChunkName: "reports" */
                        "../reports/reportsPage"
                    );
        
                    Radio.channel("main").request("show:app:view", new ReportsPage({
                        name: strings.page_reports,
                        hideDatePicker: true
                    }));
                } catch (error) {
                    ensureErrorCallback(error);
                }
            }
        }

        main();
    }, [options, level, context]);

    return null;
}
